import { Component } from '@angular/core';
import { MbCard } from '@am/moebius';

@Component({
  selector: 'am-hotels-list-skeleton',
  standalone: true,
  styleUrls: ['./hotels-list-skeleton.component.scss'],
  templateUrl: './hotels-list-skeleton.component.html',
  imports: [MbCard],
})
export class HotelsListSkeletonComponent {
  constructor() {}
}
